$(document).ready(function(){

    $('.faqs_content_col h4').click(function() {
        var $faqDescription = $(this).parents('.faqs_content_col').find('.faqs_description');
        var $faqContent = $faqDescription.find('.faqs_content_ht');
    
        if ($(this).hasClass('active')) {
            // Collapse
            $faqDescription.css('height', '0');
            $(this).removeClass('active');
        } else {
            // Expand
            var height_faq_content = $faqContent.outerHeight(true);
            $faqDescription.css('height', height_faq_content + "px");
            $(this).addClass('active');
        }
    });

    $('.faqs_labels label').click(function () {
        var targetTitle = $(this).data('label');
        var $targetSection = $('.faqs_column[data-title="' + targetTitle + '"]');
    
        if ($targetSection.length) {
            $('html, body').animate({
                scrollTop: $targetSection.offset().top - 150
            }, 800);
    
            // Highlight active section
            $('.faqs_column').removeClass('active');
            $targetSection.addClass('active');
        }
    });



  // =============================================================

  let isHeightSet = false; 
    let hoverTimeout = null; // To clear previous timeouts
    
    $('.sub_menu_link').hover(
        function() {
            clearTimeout(hoverTimeout); // Clear any pending timeout

            // $('.inline_nav_ul').css('height', '');
    
            let $this = $(this).closest('li'); // Target the parent li
            let $menu = $this.find('.header_child_menu'); // Target submenu
            
            if (!isHeightSet) {
                let headerUlHeight = $('.inline_nav_ul').height();
                let subMenuHeight = $menu.outerHeight(true); 
                let totalHeight = headerUlHeight + subMenuHeight;

                $('.inline_nav_ul').css('height', totalHeight + 'px');
                $menu.css('visibility', 'visible');
                $(this).addClass('hover_main');
                $('.header_small_logo').addClass('active');
                isHeightSet = true; 
            } else {
                $menu.css('visibility', 'visible');
                $(this).addClass('hover_main');
                 $('.header_small_logo').addClass('active');
            }
        },
        function() {
            let $this = $(this).closest('li');
            let $menu = $this.find('.header_child_menu');
    
            // hoverTimeout = setTimeout(() => {
                if (!$menu.is(':hover') && !$(this).is(':hover')) {
                  console.log('hover out');
                    $('.inline_nav_ul').css('height', '');
                    $menu.css('visibility', 'hidden');
                    $('.header_small_logo').removeClass('active');
                    $(this).removeClass('hover_main');
                    isHeightSet = false; 
                }
            // }, 200); // Slight delay to handle quick movements
        }
    );
    
    // Handle hover directly on the submenu
    $('.header_child_menu').hover(
        function() {
            clearTimeout(hoverTimeout); // Clear any pending timeout
    
            let $this = $(this).closest('li'); // Target parent li
            $this.find('.header_child_menu').css('visibility', 'visible');
            $this.find('.sub_menu_link').addClass('hover_main');
            $('.header_small_logo').addClass('active');
        },
        function() {
            let $this = $(this).closest('li');
    
            // hoverTimeout = setTimeout(() => {
                if (!$this.find('.sub_menu_link').is(':hover')) {
                    $('.inline_nav_ul').css('height', '');
                    $this.find('.header_child_menu').css('visibility', 'hidden');
                    $this.find('.sub_menu_link').removeClass('hover_main');
                    $('.header_small_logo').removeClass('active');
                    isHeightSet = false;
                }
            // }, 200); // Slight delay for smoother experience
        }
    );

    
      
          // let isHeightSet = false; 
      
          // $('.sub_menu_link').hover(
          //     function() {
          //       var $this = $(this).parents('header-menu');
          //         if (!isHeightSet) {
          //             var header_ul = $('.inline_nav_ul').height();
          //             var sub_menu_height = $('.header_child_menu').outerHeight(true); 
          //             var total_height = header_ul + sub_menu_height;
                      
                    
          //             $(this).parents('.inline_nav_ul').css('height', total_height + 'px');
          //             $this.find('.header_child_menu').css('visibility', 'visible');
          //             $this.find('.header_small_logo').addClass('active');
          //             $(this).addClass('hover_main');
          //             isHeightSet = true; 
          //         } 
          //         else 
          //         {
          //             $this.find('.header_child_menu').css('visibility', 'visible');
          //             $this.find('.header_small_logo').addClass('active');
          //             $(this).addClass('hover_main');
          //         }
                
          //     },function() {
          //         var $this = $(this).parents('header-menu');
          //         setTimeout(() => {
          //             if (!$this.find('.header_child_menu:hover').length) {
          //                 $('.inline_nav_ul').css('height', '');
          //                 $this.find('.header_child_menu').css('visibility', 'hidden');
          //                 $this.find('.header_small_logo').removeClass('active');
          //                 $this.find('.sub_menu_link').removeClass('hover_main');
          //                 isHeightSet = false; 
          //             }
          //         }, 100); 
          //     }
          // );
          
          // $('.header_child_menu').hover(
          //     function() {

          //         var $this = $(this).parents('header-menu');
          //         $this.find('.header_child_menu').css('visibility', 'visible');
          //         $this.find('.header_small_logo').addClass('active');
          //         $this.find('.sub_menu_link').addClass('hover_main');
          //     },
          //     function() {
          //         var $this = $(this).parents('header-menu');
          //         setTimeout(() => {
          //             if (!$this.find('.sub_menu_link:hover').length) {
          //                 $this.find('.inline_nav_ul').css('height', '');
          //                 $this.find('.header_child_menu').css('visibility', 'hidden');
          //                 $this.find('.header_small_logo').removeClass('active');
          //                 $this.find('.sub_menu_link').removeClass('hover_main');
          //                 isHeightSet = false;
          //             }
          //         }, 100);
          //     }
          // );
   

  // ==============================================
  
  $('.image_content_grid').slick({
  dots: true,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  });
})